import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=12ca3efe&"
import script from "./Quotation.vue?vue&type=script&lang=js&"
export * from "./Quotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ca3efe')) {
      api.createRecord('12ca3efe', component.options)
    } else {
      api.reload('12ca3efe', component.options)
    }
    module.hot.accept("./Quotation.vue?vue&type=template&id=12ca3efe&", function () {
      api.rerender('12ca3efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/customers/Edit/Quotation.vue"
export default component.exports